import { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router';

import httpInstances from '@/api/axiosInstance';
import LoadingPage from '@/components/LoadingPage';
import Factsheets from '@/pages/Facthsheets';

const Lookup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [found, setFound] = useState(false);
  useEffect(() => {
    httpInstances.axiosInternalInstance
      .get(`/factsheets/details?code=${encodeURIComponent(location.pathname.slice(1))}`)
      .then(() => {
        setFound(true);
      })
      .catch(() => {
        navigate('/notfound');
      });
  }, [location.pathname, navigate]);
  if (!found) {
    return <LoadingPage />;
  }
  return <Factsheets />;
};

export default Lookup;
